import {ContentCopy} from "@mui/icons-material";
import React from "react";
import {createUseStyles} from "react-jss";

const useStyles = createUseStyles(({ colors }) => ({
  copyButton: {
    backgroundColor: colors.adminBlue,
    color: colors.white,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "16px",
    width: "24px",
    height: "24px",
    border: "none",
    padding: 0,
    "&:hover": { color: `${colors.white}aa` },
    cursor: "pointer",
    position: "absolute",
    bottom: "-12px",
    right: "30px",
    zIndex: 10,
    outline: "none",
    "&::before": {
      content: '""',
      position: "absolute",
      top: -10,
      left: -10,
      right: -10,
      bottom: -10,
    },
    "&:focus-visible": {
      outline: "2px solid #4484F1",
      outlineOffset: "2px",
    },
  },
}));

export const CopyBlockButton = ({block, onCopy}) => {
  const classes = useStyles();

  const handleCopy = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    onCopy(block);
  };

  return (
    <button
      type="button"
      className={classes.copyButton}
      onClick={handleCopy}
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      aria-label="Kopier blokk"
    >
      <ContentCopy
        sx={{
          width: "14px",
          height: "14px",
        }}
      />
    </button>
  );
};
